import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/knowYourPaver/blog-permeable-vs-concrete-001.jpg";
import img002 from "../../images/knowYourPaver/blog-permeable-vs-concrete-002.jpg";
import img003 from "../../images/knowYourPaver/blog-permeable-vs-concrete-003.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const KnowYourPaverData = {
  title: "Know Your Paver Well: Permeable vs. Concrete Pavers",
  image: img001,
  destination: "/blog/know-your-paver-well-permeable-vs-concrete-pavers",
  date: "August 18, 2015",
  categories: ["blog", "choosing-a-paving-material"],
};

const KnowYourPaver = () => {
  const blog = [KnowYourPaverData];

  return (
    <>
      <SEO
        title="Permeable vs. Concrete Pavers - Which is Best for You?"
        description="Permeable pavers are often confused with regular pavers. However, these two pavers work differently and hence should not be used interchangeably."
        profileURL={
          "https://www.pacificpavingstone.com/blog/know-your-paver-well-permeable-vs-concrete-pavers"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/know-your-paver-well-permeable-vs-concrete-pavers ",
          headline: "Permeable vs. Concrete Pavers - Which is Best for You? ",
          description:
            "Permeable pavers are often confused with regular pavers. However, these two pavers work differently and hence should not be used interchangeably. ",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-permeable-vs-concrete-001.cb7f0076.jpg ",
          },
          datePublished: "2015-08-18",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Permeable pavers are often confused with regular pavers. However,
              these two pavers work differently and hence should not be used
              interchangeably.
              <br />
              <br />
              So what sets them apart? Let’s break it down to two factors –
              first is their base and next is the joints or gaps between them.
            </p>
            <h4>Base beneath</h4>
            <p>
              Pavers aren’t just laid on the ground surface. Installation
              involves preparing a base and how the base is set up defines the
              purpose they serve.
              <br />
              <br />
              The standard interlocking paving stone is not permeable, which
              means it does not drain water. While regular pavers are designed
              to be flexible, they are not meant to be permeable. Let’s take a
              closer look into the base of a regular paver and a permeable
              paver.
            </p>
            <img src={img002} alt="Feature" />
            <p>
              At the base of regular pavers, you’ll see large gravel, medium
              sized gravel, small gravel and what is called fines (very small
              particles). This mixture of varying gravel sizes creates a compact
              well. Add to that the fines that fill the already narrow voids,
              making the layer even tighter.
              <br />
              <br />
              This base material is not meant to drain water but rather to
              prevent water from draining through it.
              <br />
              <br />
              On the other hand, the base materials for permeable pavers are
              referred to as open graded. This is because it is made up of
              larger pieces of gravel. This large gravel pieces leave voids,
              which then allows water to pass through easily. See this figure
              below.
            </p>
            <img src={img003} alt="Feature" />
            <p>
              The purpose of permeable pavers is to allow the water to drain
              through the aquifer.
              <br />
              <br />
              In order to do that, the water must pass through the pavers, the
              open graded base, and then the subgrade or subsoil until it
              arrives at aquifer or ground water.
            </p>
            <h4>Gaps in between</h4>
            <p>
              Take a look at the photos below. See how the gap size between
              pavers differ? For permeable pavers, the joint size is wider as
              compared to a standard paver.
              <br />
              <br />
              Left: Permeable Pavers, Right: Concrete Pavers
              <br />
              <br />
              Regular pavers should be treated just like any solid surface such
              as concrete. The surface should slope away from the house and
              surface drains should be installed as needed to handle the water.
              <br />
              <br />
              Permeable pavers are designed to allow the water to drain through
              them and into the open graded base and then into the soil, called
              the sub soil.
              <br />
              <br />
              The opened graded base may consist of several different sizes of
              rocks but we will refer to it as open graded base. The water does
              not automatically seep into the soil below called subgrade or
              subsoil, and this open graded base acts as a holding tank.
              <br />
              <br />
              The design and depth of this holding tank depends on several
              factors: the subgrade, the area runoff, the amount of rain fall
              for your region, and the slope of the pavers and extreme slopes.
              <br />
              <br />
              We’ll cover these factors in our next post so if you want to be
              sure your permeable paver is designed correctly, then check that
              out as well.
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(KnowYourPaver);
